<mat-card class="py-20" style="width: max-content; max-width: 100%; box-sizing: border-box;">
    <mat-card-header>
        <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
            <div class="left">
                <mat-card-title class="">
                    Available Healthcare Services

                </mat-card-title>
                <mat-card-subtitle>
                    Find, search and add hospital services
                </mat-card-subtitle>
            </div>
            <div class="right gap-10 g-just-flex">
                <a mat-flat-button extended class="secondary-button small-button">
                    <mat-icon>file_download</mat-icon> Export
                </a>


                <!-- @if(capacityObject['medicationRequest']['request'].includes(user.role)

                ) { -->
                <a mat-flat-button extended (click)="hospital.addServices()">
                    <mat-icon>add</mat-icon> Add New Service
                </a>

                <!-- } -->



            </div>
        </div>
    </mat-card-header>

    <mat-card-content class="my-12 ">
        <mat-divider></mat-divider>
        <app-table-header [patientsTableFilterArray]="  tableFilter"
            [patientsFiltersFormControlObject]=" tableFilterFormControlObject">

        </app-table-header>


        <table mat-table matSort [dataSource]="tableDataSource" class="mat-elevation-z8 demo-table">

            <!--name - coding.code.display-->

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="action">
                    Action
                </th>
                <td mat-cell *matCellDef="let element; let i = index;" style="z-index: 99999; position:relative;">
                    <mat-icon [mat-menu-trigger-for]="mem">more_vert</mat-icon>
                    <mat-menu #mem="matMenu" class="action-menu">
                        <a>

                            <span>
                                View Details
                            </span>
                            <mat-icon class="">
                                chevron_right
                            </mat-icon>
                        </a>
                        <a (click)="hospital.addServices()">

                            <mat-icon class="">
                                edit
                            </mat-icon>
                            <span>
                                Edit
                            </span>
                        </a>
                        <a>
                            <a>
                                <mat-icon class="">
                                    delete
                                </mat-icon>
                                <span>
                                    Delete
                                </span>
                            </a>
                        </a>

                    </mat-menu>
                </td>
            </ng-container>

            <!--dateRecorded - recordedDateTime -->


            @for(column of tableColumns; track $index;){
            @if(column !== 'actions'){
            <ng-container matColumnDef="{{column}}">
                <th mat-header-cell *matHeaderCellDef>
                    {{column | titlecase}}
                </th>
                <td mat-cell *matCellDef="let element; let i = index;" #td>
                    @if(column == 'contact'){

                    @for(contact of element.contact?.[0]?.telecom?.slice(0, 2); track $index;){
                    <div class="g-just-flex gap-0 my-12 link-group"
                        style="justify-content: flex-start; align-items: center;">
                        <div class="g-just-flex gap-5 link-group-words"
                            style="justify-content: flex-start; align-items: flex-start; flex-direction: column;">
                            @if((element.contact?.[0]?.telecom?.slice(0, 2).length > 1 &&
                            contact.system == 'email') || (element.contact?.[0]?.telecom?.slice(0, 2).length == 1)
                            ){
                            <div class="top g-just-flex " style="justify-content: flex-start;">
                                <a [attr.href]="(contact.system=='email'?'mailto:':'')+contact.value"
                                    class=" g-just-flex " style="justify-content: flex-start; align-items: center;">

                                    <mat-icon class="me-10" style="font-size: 14px; height: 14px; width: 14px;
                                    color:var(--mat-sys-on-background);
                                    ">
                                        {{contact.system == 'email'?'mail': 'phone'}}
                                    </mat-icon>

                                    <span [style]="'color:var(--mat-sys-on-background)'">
                                        {{contact.value}}
                                    </span>
                                </a>




                            </div>}
                            @else {
                            <div class="bottom subtitle-text-color-2 link-group-icon g-just-flex "
                                style="justify-content: flex-start;">

                                <a [attr.href]="(contact.system=='phone'?'tel:':'')+contact.value" class=" g-just-flex "
                                    style="justify-content: flex-start; align-items: center;">

                                    <mat-icon class="me-10" style="font-size: 14px; height: 14px; width: 14px;
                                    color:var(--mat-sys-on-background)
                                    ">
                                        {{contact.system == 'email'?'mail': 'phone'}}
                                    </mat-icon>

                                    <span [style]="'color:var(--mat-sys-on-background)'">
                                        {{contact.value}}
                                    </span>
                                </a>



                            </div>
                            }
                        </div>

                    </div>
                    }@empty {
                    {{'N/A'}}
                    }
                    }@else{
                    @if(column == 'type' || column == 'category'){
                    {{element.type?.[0]? (element.type[0] | codeableConcept2 | titlecase) : 'N/A'}}
                    }@else if(column == 'name'){

                    {{element.name || 'N/A'}}

                    }@else if(column == 'phone'){
                    }@else{

                    {{element[column]}}
                    }
                    }

                    <!-- //replace all above with medicationCodeableConcept instead of medication -->


                </td>
            </ng-container>
            }
            }



            <!--category - category.coding.display -->





            <!--clinicalStatus - clinicalStatus.coding[0].code -->


            <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
            <tr mat-row *matRowDef="let row; let dataIndex = dataIndex; columns: tableColumns" (click)="showRow(row)">
            </tr>
        </table>
    </mat-card-content>
</mat-card>